import styles from './TermsOfService.module.css';

export default function TermsOfService() {
    return (
        <div className={styles.background}>
            <div className={styles.container}>
                <div className={styles.content}>
                    <span className={styles.header}>
                        StellarFX Labs Terms of Service
                    </span>
                    Last Updated: Apr 25, 2024
                    <p>
                        These Terms of Use (these “
                        <span style={{ fontWeight: 'bold' }}>Terms</span>”)
                        govern your access to and use of certain products,
                        services and properties made available by StellarFX Labs
                        Inc. (“
                        <span style={{ fontWeight: 'bold' }}>
                            StellarFX Labs,
                        </span>
                        ” “<span style={{ fontWeight: 'bold' }}>we,</span>” “
                        <span style={{ fontWeight: 'bold' }}>us</span>” or “
                        <span style={{ fontWeight: 'bold' }}>our</span>”). (As
                        used herein, the term “
                        <span style={{ fontWeight: 'bold' }}>you</span>”
                        (including any variant) refers to each individual who
                        enters into these Terms on such individual’s own behalf
                        or any entity on behalf of which an individual enters
                        into these Terms.) Our products, services and properties
                        include, without limitation, our online services,
                        including the website through which these Terms are made
                        available (the “
                        <span style={{ fontWeight: 'bold' }}>Website</span>”),
                        our web-hosted user interface (the “
                        <span style={{ fontWeight: 'bold' }}>Interface</span>”),
                        and software provided on or in connection with those
                        services (collectively, the “
                        <span style={{ fontWeight: 'bold' }}>Service</span>”).
                        Certain features of the Service may be subject to
                        additional guidelines, terms, or rules (“
                        <span style={{ fontWeight: 'bold' }}>
                            Supplemental Terms
                        </span>
                        ”), which will be displayed in connection with such
                        features. These Terms and all such Supplemental Terms,
                        which are incorporated by reference, are collectively
                        referred to as the “
                        <span style={{ fontWeight: 'bold' }}>Agreement</span>.”
                        If these Terms are inconsistent with any Supplemental
                        Terms, the Supplemental Terms shall control solely with
                        respect to such services. To access or use any of our
                        Services, you must be able to form a legally binding
                        contract with us. Accordingly, you represent that you
                        are at least the age of majority in your jurisdiction
                        (e.g., 18 years old in the United States) and have the
                        full right, power, and authority to enter into and
                        comply with the terms and conditions of this Agreement
                        on behalf of yourself and any company or legal entity
                        for which you may access or use the Interface. If you
                        are entering into this Agreement on behalf of an entity,
                        you represent to us that you have the legal authority to
                        bind such entity.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            PLEASE READ SECTION 12 OF THIS AGREEMENT CAREFULLY,
                            AS IT CONTAINS AN ARBITRATION AGREEMENT WHICH WILL,
                            WITH LIMITED EXCEPTIONS, REQUIRE DISPUTES BETWEEN US
                            TO BE SUBMITTED TO BINDING AND FINAL ARBITRATION.
                            UNLESS YOU OPT OUT OF THE ARBITRATION AGREEMENT: (1)
                            YOU WILL ONLY BE PERMITTED TO PURSUE CLAIMS AND SEEK
                            RELIEF AGAINST US ON AN INDIVIDUAL BASIS, NOT AS A
                            PLAINTIFF OR CLASS MEMBER IN ANY CLASS OR
                            REPRESENTATIVE ACTION OR PROCEEDING; AND (2) YOU ARE
                            AGREEING TO MANDATORY INDIVIDUAL ARBITRATION FOR THE
                            RESOLUTION OF DISPUTES AND WAIVING YOUR RIGHT TO A
                            JURY TRIAL ON YOUR CLAIMS.{' '}
                        </span>
                    </p>
                    <p>
                        We reserve the right, in our sole discretion, to modify
                        this Agreement from time to time. If we make any
                        material modifications, we will notify you by updating
                        the date at the top of the Agreement and by maintaining
                        a current version of the Agreement on our Website. All
                        modifications will be effective when they are posted,
                        and your continued accessing or use of any of the
                        Services will serve as confirmation of your acceptance
                        of those modifications. If you do not agree with any
                        modifications to this Agreement, you must immediately
                        stop accessing and using all of our Services.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            OUR SERVICES.
                        </span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            The Interface; The Protocol.
                        </span>
                    </p>
                    <p>
                        The Interface provides a web or mobile-based means of
                        access to a decentralized protocol on various public
                        blockchains, including but not limited to Ethereum, that
                        allows users to trade certain compatible digital assets
                        (the&nbsp; “
                        <span style={{ fontWeight: 'bold' }}>Protocol</span>”).
                        The Interface may also provide information and data
                        about digital assets or tokens.
                    </p>
                    <p>
                        The Interface is distinct from the Protocol and is one,
                        but not the exclusive, means of accessing the Protocol.
                        The Protocol comprises open-source or source- available
                        self-executing smart contracts that are deployed on
                        various public blockchains, such as the Ethereum
                        blockchain. StellarFX Labs does not control or operate
                        any version of the Protocol on any blockchain network.
                        By using the Interface, you understand that you are not
                        buying or selling digital assets from us and that we do
                        not operate any liquidity pools on the Protocol or
                        control trade execution on the Protocol. When traders
                        pay fees for trades, those fees accrue to liquidity
                        providers for the Protocol. StellarFX Labs is not a
                        liquidity provider into Protocol liquidity pools and
                        liquidity providers are independent third parties.
                        Deployments on other networks typically make use of
                        cross-chain bridges, which allow assets native to one
                        blockchain to be transferred to another blockchain.
                        Please note that digital assets that have been “
                        <span style={{ fontWeight: 'bold' }}>bridged</span>” or
                        “<span style={{ fontWeight: 'bold' }}>wrapped</span>” to
                        operate on other blockchain networks (including to
                        blockchains compatible with the Ethereum Virtual Machine
                        that are designed to ensure the Ethereum blockchain can
                        effectively process more transactions or other
                        blockchains that are frequently referred to as “
                        <span style={{ fontWeight: 'bold' }}>Layer 2</span>”
                        solutions) are distinct from the original Ethereum
                        main-net asset.{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>Trading. </span>You
                        agree and understand that: (a) all trades you submit
                        through any of our Services are considered unsolicited,
                        which means that they are solely initiated by you; (b)
                        you have not received any investment advice from us in
                        connection with any trades; and (c) we do not conduct a
                        suitability review of any trades you submit.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            1.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Digital Wallet.{' '}
                        </span>
                        To access the Interface, you must use a non-custodial
                        electronic wallet that allows you to purchase, store,
                        and engage in transactions using cryptocurrency and
                        other digital assets (each, a “
                        <span style={{ fontWeight: 'bold' }}>
                            Digital Wallet
                        </span>
                        ”) on supported bridge extensions.&nbsp; ALL
                        TRANSACTIONS INITIATED THROUGH OUR SERVICE ARE EFFECTED
                        BY THIRD-PARTY DIGITAL WALLET EXTENSIONS. BY USING OUR
                        SERVICES YOU AGREE THAT SUCH TRANSACTIONS ARE GOVERNED
                        BY THE TERMS OF SERVICE AND PRIVACY POLICY FOR THE
                        APPLICABLE EXTENSIONS. We accept no responsibility for,
                        or liability to you in connection with, your use of a
                        Digital Wallet and make no representations or warranties
                        regarding how any of our Services will operate with any
                        specific Digital Wallet. Likewise, we are not liable for
                        any acts or omissions by you in connection with or as a
                        result of your Digital Wallet being compromised. By
                        connecting your Digital Wallet to our Interface, you
                        agree to be bound by this Agreement and all of the terms
                        incorporated herein by reference.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            1.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Non-Custodial and No Fiduciary Duties.{' '}
                        </span>
                        StellarFX Labs never has custody, possession, or control
                        of your digital assets at any time. Accordingly, you are
                        solely responsible for the custody of the cryptographic
                        private keys to your Digital Wallet and you should never
                        share your Digital Wallet credentials with anyone. This
                        Agreement is not intended to, and does not, create or
                        impose any fiduciary duties on us. To the fullest extent
                        permitted by law, you acknowledge and agree that we owe
                        no fiduciary duties or liabilities to you or any other
                        party, and that to the extent any such duties or
                        liabilities may exist at law or in equity, those duties
                        and liabilities are hereby irrevocably disclaimed,
                        waived, and eliminated. You further agree that the only
                        duties and obligations that we owe you are those set out
                        expressly in this Agreement.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            1.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Compliance and Tax Obligations.{' '}
                        </span>
                        One or more of our Services may not be available or
                        appropriate for use in your jurisdiction. By accessing
                        or using any of our Services, you agree that you are
                        solely and entirely responsible for compliance with all
                        laws and regulations that may apply to you.
                        Specifically, your use of our Services or the Protocol
                        may result in various tax consequences, such as income
                        or capital gains tax, value-added tax, goods and
                        services tax, or sales tax in certain jurisdictions. It
                        is your responsibility to determine whether taxes apply
                        to any transactions you initiate or receive and, if so,
                        to report and/or remit the correct tax to the
                        appropriate tax authority.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            1.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Other Services; Modifications.{' '}
                        </span>
                        We may from time to time in the future offer additional
                        products or services, and such additional products or
                        services shall be considered a “Service” as used herein.
                        We reserve the following rights, which do not constitute
                        obligations of ours: (a) with or without notice to you,
                        to modify, substitute, eliminate or add to any of the
                        Services; (b) to review, modify, filter, disable, delete
                        and remove any and all content and information from any
                        of the Services.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            INTELLECTUAL PROPERTY RIGHTS.{' '}
                        </span>
                        We own all intellectual property and other rights in
                        each of our Services and its respective contents,
                        including, but not limited to, software, text, images,
                        trademarks, service marks, copyrights, patents, designs,
                        and its “look and feel.” &nbsp;Subject to the terms of
                        this Agreement, we grant you a limited, revocable,
                        non-exclusive, non-sublicensable, non-transferable
                        license to access and use our Services solely in
                        accordance with this Agreement. You agree that you will
                        not use, modify, distribute, tamper with, reverse
                        engineer, disassemble or decompile any of our Services
                        for any purpose other than as expressly permitted
                        pursuant to this Agreement. Except as set forth in this
                        Agreement, we grant you no rights to any of our
                        Services, including any intellectual property rights.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            User Representations and Warranties.
                        </span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            3.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        By using the Service, you agree to maintain the security
                        of your Digital Wallet and accept all risks of
                        unauthorized access to your Digital Wallet and to the
                        information you provide to us. You agree that you will
                        not (i) buy, sell, rent, or lease access to the Service
                        or (ii) attempt to access the Service through
                        unauthorized third party applications or clients.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            3.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        StellarFX Labs may require you to provide additional
                        information and documents from time to time, including
                        without limitation at the request of any competent
                        authority or in order to help StellarFX Labs comply with
                        applicable law, regulation, or policy, including laws
                        related to anti-laundering (legalization) of incomes
                        obtained by criminal means, or for counteracting
                        financing of terrorism. StellarFX Labs may also require
                        you to provide additional information and documents in
                        cases where it has reasons to believe that: (i) your
                        Digital Wallet or other access to the Service is being
                        used for money laundering or for any other illegal
                        activity; (ii) you have concealed or reported false
                        identification information and other details; or (iii)
                        transactions effected via your Digital Wallet were
                        effected in breach of this Agreement. In such cases,
                        StellarFX Labs, in its sole discretion, may pause or
                        cancel your transactions until such requested additional
                        information and documents have been reviewed by
                        StellarFX Labs and accepted as satisfying the
                        requirements of applicable law, regulation, or policy.
                        If you do not provide complete and accurate information
                        and documents in response to such a request, StellarFX
                        Labs may refuse to provide you with further access to
                        the Service.<span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        When you use the Service, you hereby represent and
                        warrant, to and for the benefit of StellarFX Labs, its
                        affiliates, and its and their respective
                        representatives, as follows: (i) you are sophisticated,
                        experienced and knowledgeable regarding blockchain
                        technology and digital assets; (ii) you have conducted
                        an independent investigation of the Service and the
                        matters contemplated by this Agreement, have formed your
                        own independent judgment regarding the benefits and
                        risks of and necessary and desirable practices regarding
                        the foregoing, and, in making the determination to use
                        the Service, you have relied solely on the results of
                        such investigation and such independent judgement; (iii)
                        without limiting the generality of the foregoing, you
                        understand, acknowledge and agree that the legal
                        requirements pertaining to blockchain technologies and
                        digital assets generally, are uncertain, and you have
                        conducted an independent investigation of such
                        potentially applicable legal requirements and the
                        resulting risks and uncertainties; (iv) there is no
                        legal proceeding pending that relates to your activities
                        relating to token- or digital asset- trading or
                        blockchain technology related activities; (v) you have
                        not failed to comply with, and have not violated, any
                        applicable legal requirement relating to any blockchain
                        technologies or token-trading activities; and (vi) no
                        investigation or review by any governmental entity is
                        pending or, to your knowledge, has been threatened
                        against or with respect to you, nor does any government
                        order or action prohibit you or any of your
                        representatives from engaging in or continuing any
                        conduct, activity or practice relating to the Service
                        and cryptocurrency. You hereby irrevocably disclaim and
                        disavow reliance upon any statements or representations
                        made by or on behalf of, or information made available
                        by, StellarFX Labs, in determining to enter into this
                        Agreement or otherwise use the Service.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Your Responsibilities.
                        </span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            4.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Acceptable Use Policy.{' '}
                        </span>
                        You agree not to engage in, or attempt to engage in, or
                        knowingly facilitate any of the following categories of
                        prohibited activity in relation to your access and use
                        of the Services:
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        a.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Activity that seeks to
                        interfere with or compromise the integrity, security, or
                        proper functioning of any computer, server, network,
                        personal device, or other information technology system,
                        including, but not limited to, the deployment of viruses
                        and denial of service attacks;
                    </p>
                    <p>
                        b.&nbsp;&nbsp;&nbsp;&nbsp; Use the Service in any manner
                        that could interfere with, disrupt, negatively affect or
                        inhibit others from fully enjoying the Service, or that
                        could damage, disable, overburden or impair the
                        functioning of the Service in any manner;
                    </p>
                    <p>
                        c.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Use any robot, spider,
                        crawler, scraper, script, browser extension, offline
                        reader, or other automated means or interface not
                        authorized by us to access the Service, extract data or
                        otherwise interfere with or modify the rendering of
                        Service pages or functionality;
                    </p>
                    <p>
                        d.&nbsp;&nbsp;&nbsp;&nbsp; Activity that seeks to bypass
                        or ignore instructions that control all automated access
                        to the Service;
                    </p>
                    <p>
                        e.&nbsp;&nbsp;&nbsp;&nbsp; Activity that seeks to
                        defraud us or any other person or entity, including, but
                        not limited to, providing any false, inaccurate, or
                        misleading information in order to unlawfully obtain the
                        property of another;
                    </p>
                    <p>
                        f.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Any “rug pulls,”
                        “front-running,” “wash trading,” “pump and dump
                        trading,” “ramping,” “cornering” or fraudulent,
                        deceptive or manipulative trading activities;
                    </p>
                    <p>
                        g.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Any harm or explicit
                        loss of value to, or otherwise manipulate, another
                        protocol based on learnings from the Services;
                    </p>
                    <p>
                        h.&nbsp;&nbsp;&nbsp;&nbsp; Any artificial inflation in
                        pricing for any tangible or intangible item or anything
                        of value, including, without limitation, any token,
                        security or currency;
                    </p>
                    <p>
                        i.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Any unlawful or
                        illicit conversion of any tangible or intangible item or
                        anything of value, including, without limitation, any
                        token, security or currency;
                    </p>
                    <p>
                        j.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Any artificial
                        increase in the value of any collateral;
                    </p>
                    <p>
                        k.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Any borrowing of assets
                        without intention or means to repay same;
                    </p>
                    <p>
                        l.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Any unjust
                        enrichment;
                    </p>
                    <p>
                        m.&nbsp;&nbsp;&nbsp; Any misappropriation or unlawful
                        conversion of funds;
                    </p>
                    <p>
                        n.&nbsp;&nbsp;&nbsp;&nbsp; Any improper exploitation of
                        vulnerabilities of any protocol, platform, or system of
                        any nature;
                    </p>
                    <p>
                        o.&nbsp;&nbsp;&nbsp;&nbsp; Any malicious attacks on any
                        protocol or system of any nature;
                    </p>
                    <p>
                        p.&nbsp;&nbsp;&nbsp;&nbsp; Any commodities or securities
                        fraud;{' '}
                    </p>
                    <p>
                        q.&nbsp;&nbsp;&nbsp;&nbsp; Activity that violates any
                        applicable law, rule, or regulation concerning the
                        trading of securities or derivatives, including, but not
                        limited to, the unregistered offering of securities and
                        the offering of leveraged and margined commodity
                        products to retail customers in the United States.
                    </p>
                    <p>
                        r.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Purchase, sale, or
                        transfer of stolen items, fraudulently obtained items,
                        items taken without authorization, and/or any other
                        illegally obtained items.
                    </p>
                    <p>
                        s.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Activity that involves
                        data mining, robots, scraping, or similar data gathering
                        or extraction methods of content or information from any
                        of our Services.
                    </p>
                    <p>
                        t.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Activity that violates
                        any applicable law, rule, or regulation of the United
                        States or another relevant jurisdiction, including, but
                        not limited to, the restrictions and regulatory
                        requirements imposed by U.S. law.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            4.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>Gas Fees. </span>
                        Blockchain transactions require the payment of
                        transaction fees to the appropriate network (“
                        <span style={{ fontWeight: 'bold' }}>Gas Fees</span>”).
                        Except as otherwise expressly set forth in the terms of
                        another offer by StellarFX Labs, you will be solely
                        responsible to pay the Gas Fees for any transaction that
                        you initiate via any of our Services.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            4.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Necessary Equipment.{' '}
                        </span>
                        You must provide all equipment and software necessary to
                        connect to the Service. You are solely responsible for
                        any fees, including Internet connection or mobile fees,
                        that you incur when accessing the Service.{' '}
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>DISCLAIMERS.</span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            5.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Assumption of Risk Generally.{' '}
                        </span>
                        YOU UNDERSTAND THAT THE MARKETS FOR DIGITAL ASSETS ARE
                        NASCENT AND HIGHLY VOLATILE DUE TO RISK FACTORS
                        INCLUDING, BUT NOT LIMITED TO, ADOPTION, SPECULATION,
                        TECHNOLOGY, SECURITY, AND REGULATION. STABLECOINS MAY
                        NOT BE AS STABLE AS THEY PURPORT TO BE, MAY NOT BE FULLY
                        OR ADEQUATELY COLLATERALIZED, AND MAY BE SUBJECT TO
                        PANICS AND RUNS. FURTHER, YOU UNDERSTAND THAT SMART
                        CONTRACT TRANSACTIONS AUTOMATICALLY EXECUTE AND SETTLE,
                        AND THAT BLOCKCHAIN BASED TRANSACTIONS ARE IRREVERSIBLE
                        WHEN CONFIRMED. YOU ACKNOWLEDGE AND ACCEPT THAT THE COST
                        AND SPEED OF TRANSACTING WITH CRYPTOGRAPHIC AND
                        BLOCKCHAIN BASED SYSTEMS SUCH AS ETHEREUM ARE VARIABLE
                        AND MAY INCREASE DRAMATICALLY AT ANY TIME. IF YOU ACT AS
                        A LIQUIDITY PROVIDER TO THE PROTOCOL THROUGH THE
                        INTERFACE, YOU UNDERSTAND THAT YOUR DIGITAL ASSETS MAY
                        LOSE SOME OR ALL OF THEIR VALUE WHILE THEY ARE SUPPLIED
                        TO THE PROTOCOL THROUGH THE INTERFACE DUE TO THE
                        FLUCTUATION OF PRICES OF TOKENS IN A TRADING PAIR OR
                        LIQUIDITY POOL. FINALLY, YOU UNDERSTAND THAT WE DO NOT
                        CREATE, OWN, OR OPERATE CROSS CHAIN BRIDGES AND WE DO
                        NOT MAKE ANY REPRESENTATION OR WARRANTY ABOUT THE SAFETY
                        OR SOUNDNESS OF ANY CROSS CHAIN BRIDGE, INCLUDING ITS
                        USE FOR PROTOCOL GOVERNANCE. IN SUMMARY, YOU ACKNOWLEDGE
                        THAT WE ARE NOT RESPONSIBLE FOR ANY OF THESE VARIABLES
                        OR RISKS, DO NOT OWN OR CONTROL THE PROTOCOL, AND CANNOT
                        BE HELD LIABLE FOR ANY RESULTING LOSSES THAT YOU
                        EXPERIENCE WHILE ACCESSING OR USING ANY OF OUR SERVICES.
                        ACCORDINGLY, YOU UNDERSTAND AND AGREE TO ASSUME FULL
                        RESPONSIBILITY FOR ALL OF THE RISKS OF ACCESSING AND
                        USING THE INTERFACE TO INTERACT WITH THE PROTOCOL.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            5.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            No Warranties.
                        </span>
                    </p>
                    <p>
                        EACH OF OUR SERVICES ARE PROVIDED ON AN “
                        <span style={{ fontWeight: 'bold' }}>AS IS</span>” AND “
                        <span style={{ fontWeight: 'bold' }}>AS AVAILABLE</span>
                        ” BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW, WE
                        DISCLAIM ANY REPRESENTATIONS AND WARRANTIES OF ANY KIND,
                        WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING, BUT
                        NOT LIMITED TO, THE WARRANTIES OF MERCHANTABILITY AND
                        FITNESS FOR A PARTICULAR PURPOSE. YOU ACKNOWLEDGE AND
                        AGREE THAT YOUR USE OF EACH OF OUR SERVICES IS AT YOUR
                        OWN RISK. WE DO NOT REPRESENT OR WARRANT THAT ACCESS TO
                        ANY OF OUR SERVICES WILL BE CONTINUOUS, UNINTERRUPTED,
                        TIMELY, OR SECURE; THAT THE INFORMATION CONTAINED IN ANY
                        OF OUR SERVICES WILL BE ACCURATE, RELIABLE, COMPLETE, OR
                        CURRENT; OR THAT ANY OF OUR SERVICES WILL BE FREE FROM
                        ERRORS, DEFECTS, VIRUSES, OR OTHER HARMFUL ELEMENTS. NO
                        ADVICE, INFORMATION, OR STATEMENT THAT WE MAKE SHOULD BE
                        TREATED AS CREATING ANY WARRANTY CONCERNING ANY OF OUR
                        SERVICES. WE DO NOT ENDORSE, GUARANTEE, OR ASSUME
                        RESPONSIBILITY FOR ANY ADVERTISEMENTS, OFFERS, OR
                        STATEMENTS MADE BY THIRD PARTIES CONCERNING ANY OF OUR
                        SERVICES.
                    </p>
                    <p>
                        SIMILARLY, THE PROTOCOL IS PROVIDED “AS IS”, AT YOUR OWN
                        RISK, AND WITHOUT WARRANTIES OF ANY KIND. WE DO NOT
                        PROVIDE, OWN, OR CONTROL THE PROTOCOL, WHICH IS RUN
                        AUTONOMOUSLY WITHOUT ANY HEADCOUNT BY SMART CONTRACTS
                        DEPLOYED ON VARIOUS BLOCKCHAINS. NO DEVELOPER OR ENTITY
                        INVOLVED IN CREATING THE PROTOCOL WILL BE LIABLE FOR ANY
                        CLAIMS OR DAMAGES WHATSOEVER ASSOCIATED WITH YOUR USE,
                        INABILITY TO USE, OR YOUR INTERACTION WITH OTHER USERS
                        OF, THE PROTOCOL, INCLUDING ANY DIRECT, INDIRECT,
                        INCIDENTAL, SPECIAL, EXEMPLARY, PUNITIVE OR
                        CONSEQUENTIAL DAMAGES, OR LOSS OF PROFITS,
                        CRYPTOCURRENCIES, TOKENS, OR ANYTHING ELSE OF VALUE. WE
                        DO NOT ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR
                        ANY ADVERTISEMENTS, OFFERS, OR STATEMENTS MADE BY THIRD
                        PARTIES CONCERNING ANY OF OUR SERVICES.
                    </p>
                    <p>
                        ANY PAYMENTS OR FINANCIAL TRANSACTIONS THAT YOU ENGAGE
                        IN WILL BE PROCESSED VIA AUTOMATED SMART CONTRACTS. ONCE
                        EXECUTED, WE HAVE NO CONTROL OVER THESE PAYMENTS OR
                        TRANSACTIONS, NOR DO WE HAVE THE ABILITY TO REVERSE ANY
                        PAYMENTS OR TRANSACTIONS.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            5.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Third-Party Data.{' '}
                        </span>
                        WE MAY PROVIDE INFORMATION ON THE SERVICES, INCLUDING
                        INFORMATION ABOUT VARIOUS DIGITAL ASSETS, SOURCED FROM
                        THIRD PARTIES (“
                        <span style={{ fontWeight: 'bold' }}>
                            THIRD-PARTY DATA
                        </span>
                        ”). FOR THE AVOIDANCE OF DOUBT, StellarFX LABS DOES NOT
                        MAKE ANY WARRANTIES ABOUT THE ACCURACY OR RELIABILITY OF
                        THIRD-PARTY DATA. YOU AGREE IT IS IMPOSSIBLE FOR
                        StellarFX LABS TO MONITOR ANY THIRD-PARTY DATA AND DO
                        NOT RELY ON StellarFX LABS TO VERIFY THE ACCURACY OF
                        SUCH THIRD-PARTY DATA.&nbsp;{' '}
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            5.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Not Investment Advice.{' '}
                        </span>
                        ANY INFORMATION PROVIDED BY ANY OF OUR SERVICES IS FOR
                        INFORMATIONAL PURPOSES ONLY AND SHOULD NOT BE CONSTRUED
                        AS INVESTMENT ADVICE OR A RECOMMENDATION THAT A
                        PARTICULAR TOKEN OR OTHER DIGITAL ASSET IS A SAFE OR
                        SOUND INVESTMENT.&nbsp; YOU SHOULD NOT TAKE, OR REFRAIN
                        FROM TAKING, ANY ACTION BASED ON ANY INFORMATION YOU
                        ACCESS THROUGH THE SERVICES. BY PROVIDING TOKEN
                        INFORMATION FOR YOUR CONVENIENCE, WE DO NOT MAKE ANY
                        INVESTMENT RECOMMENDATIONS TO YOU OR OPINE ON THE MERITS
                        OF ANY TRANSACTION OR OPPORTUNITY. YOU ALONE ARE
                        RESPONSIBLE FOR DETERMINING WHETHER ANY INVESTMENT,
                        INVESTMENT STRATEGY OR RELATED TRANSACTION IS
                        APPROPRIATE FOR YOU BASED ON YOUR PERSONAL INVESTMENT
                        OBJECTIVES, FINANCIAL CIRCUMSTANCES, AND RISK TOLERANCE.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            6.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>THIRD-PARTY </span>
                        <span style={{ fontWeight: 'bold' }}>
                            PROPERTIES; THIRD-PARTY APPLICATIONS.{' '}
                        </span>
                        The Service may contain links to third-party properties
                        (“
                        <span style={{ fontWeight: 'bold' }}>
                            Third-Party Properties
                        </span>
                        ”) and applications (“
                        <span style={{ fontWeight: 'bold' }}>
                            Third-Party Applications
                        </span>
                        ”). When you click on a link to a Third-Party Property
                        or Third-Party Application, such as a bridge extension,
                        you are subject to the terms and conditions (including
                        privacy policies) of such other property or application.
                        Such Third-Party Properties and Third-Party Applications
                        are not under the control of StellarFX Labs. StellarFX
                        Labs is not responsible for any Third-Party Properties
                        or Third-Party Applications. StellarFX Labs provides
                        links to these Third-Party Properties and Third-Party
                        Applications only as a convenience and does not review,
                        approve, monitor, endorse, warrant, or make any
                        representations with respect to Third-Party Properties
                        or Third-Party Applications, or their products or
                        services. You use all links in Third-Party Properties,
                        and Third-Party Applications at your own risk. When you
                        leave our Service, our Terms and policies no longer
                        govern. You should review all applicable agreements and
                        policies, including privacy and data gathering
                        practices, of any Third-Party Properties or Third-Party
                        Applications, and should make whatever investigation you
                        feel necessary or appropriate before proceeding with any
                        transaction with any third party.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            7.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Indemnification
                        </span>
                        <span style={{ fontWeight: 'bold' }}>. </span>You agree
                        to hold harmless, release, defend, and indemnify us and
                        our officers, directors, employees, contractors, agents,
                        affiliates, and subsidiaries from and against all
                        claims, damages, obligations, losses, liabilities,
                        costs, and expenses arising from: (a) your access and
                        use of any of our Services; (b) your violation of any
                        term or condition of this Agreement, the right of any
                        third party, or any other applicable law, rule, or
                        regulation; (c) any other party’s access and use of any
                        of our Services with your assistance or using any device
                        or account that you own or control; and (d) any dispute
                        between you and (i) any other user of any of the
                        Services or (ii) any of your own customers or users.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            8.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            RELEASE OF CLAIMS.{' '}
                        </span>
                        You expressly agree that you assume all risks in
                        connection with your access and use of any of our
                        Services. You further expressly waive and release us
                        from any and all liability, claims, causes of action, or
                        damages arising from or in any way relating to your use
                        of any of our Services. If you are a California
                        resident, you waive the benefits and protections of
                        California Civil Code § 1542, which provides: “A general
                        release does not extend to claims that the creditor or
                        releasing party does not know or suspect to exist in his
                        or her favor at the time of executing the release and
                        that, if known by him or her, would have materially
                        affected his or her settlement with the debtor or
                        released party.”
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            9.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            INVESTIGATIONS.{' '}
                        </span>
                        If StellarFX Labs becomes aware of any possible
                        violations by you of this Agreement, StellarFX Labs
                        reserves the right to investigate such violations. If,
                        as a result of the investigation, StellarFX Labs
                        believes that criminal activity may have occurred,
                        StellarFX Labs reserves the right to refer the matter
                        to, and to cooperate with, any and all applicable legal
                        authorities. StellarFX Labs is entitled, except to the
                        extent prohibited by applicable law, to disclose any
                        information or materials on or in the Service in
                        StellarFX Labs’ possession in connection with your use
                        of the Service, to (i) comply with applicable laws,
                        legal process or governmental request; (ii) enforce this
                        Agreement, or (iii) protect the rights, property or
                        personal safety of StellarFX Labs, its users, or the
                        public, and all law enforcement or other government
                        officials, as StellarFX Labs in its sole discretion
                        believes to be necessary or appropriate. By agreeing to
                        this Agreement, you hereby provide your irrevocable
                        consent to the foregoing. You acknowledge and agree that
                        you have no expectation of privacy concerning your use
                        of the Services.{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            10.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Limitation of Liability
                        </span>
                        <span style={{ fontWeight: 'bold' }}>.</span>
                    </p>
                    <p>
                        UNDER NO CIRCUMSTANCES SHALL WE OR ANY OF OUR OFFICERS,
                        DIRECTORS, EMPLOYEES, CONTRACTORS, AGENTS, AFFILIATES,
                        OR SUBSIDIARIES BE LIABLE TO YOU FOR ANY INDIRECT,
                        PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
                        EXEMPLARY DAMAGES, INCLUDING, BUT NOT LIMITED TO,
                        DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, OR
                        OTHER INTANGIBLE PROPERTY, ARISING OUT OF OR RELATING TO
                        ANY ACCESS OR USE OF OR INABILITY TO ACCESS OR USE THE
                        SERVICES, NOR WILL WE BE RESPONSIBLE FOR ANY DAMAGE,
                        LOSS, OR INJURY RESULTING FROM HACKING, TAMPERING, OR
                        OTHER UNAUTHORIZED ACCESS OR USE OF THE SERVICES OR THE
                        INFORMATION PROVIDED VIA THE SERVICES, WHETHER SUCH
                        DAMAGES ARE BASED IN CONTRACT, TORT, NEGLIGENCE, STRICT
                        LIABILITY, OR OTHERWISE, ARISING OUT OF OR IN CONNECTION
                        WITH AUTHORIZED OR UNAUTHORIZED USE OF THE SERVICES,
                        EVEN IF AN AUTHORIZED REPRESENTATIVE OF StellarFX LABS
                        HAS BEEN ADVISED OF OR KNEW OR SHOULD HAVE KNOWN OF THE
                        POSSIBILITY OF SUCH DAMAGES. WE ASSUME NO LIABILITY OR
                        RESPONSIBILITY FOR ANY (A) ERRORS, MISTAKES, OR
                        INACCURACIES OF CONTENT; (B) PROPERTY DAMAGE, OF ANY
                        NATURE WHATSOEVER, RESULTING FROM ANY ACCESS OR USE OF
                        THE INTERFACE, THE PROTOCOL, OR THE SERVICES; (C)
                        UNAUTHORIZED ACCESS OR USE OF ANY SECURE SERVER OR
                        DATABASE IN OUR CONTROL, OR THE USE OF ANY INFORMATION
                        OR DATA STORED THEREIN; (D) INTERRUPTION OR CESSATION OF
                        FUNCTION OF THE SERVICES; (E) BUGS, VIRUSES, TROJAN
                        HORSES, OR THE LIKE THAT MAY BE TRANSMITTED TO OR
                        THROUGH THE INTERFACE; (F) ERRORS OR OMISSIONS IN, OR
                        LOSS OR DAMAGE INCURRED AS A RESULT OF THE USE OF ANY
                        CONTENT MADE AVAILABLE THROUGH THE SERVICES; AND (G) THE
                        ILLEGAL CONDUCT OF ANY THIRD PARTY.
                    </p>
                    <p>
                        WE HAVE NO LIABILITY TO YOU OR TO ANY THIRD PARTY FOR
                        ANY CLAIMS OR DAMAGES THAT MAY ARISE AS A RESULT OF ANY
                        PAYMENTS OR TRANSACTIONS THAT YOU ENGAGE IN VIA THE
                        SERVICES, OR ANY OTHER PAYMENT OR TRANSACTIONS THAT YOU
                        CONDUCT VIA THE SERVICES. &nbsp;
                    </p>
                    <p>
                        WE MAKE NO WARRANTIES OR REPRESENTATIONS, EXPRESS OR
                        IMPLIED, ABOUT LINKED THIRD PARTY PROPERTIES, THE THIRD
                        PARTIES THEY ARE OWNED AND OPERATED BY, THE INFORMATION
                        CONTAINED ON THEM, ASSETS AVAILABLE THROUGH THEM, OR THE
                        SUITABILITY, PRIVACY, OR SECURITY OF THEIR PRODUCTS OR
                        SERVICES. YOU ACKNOWLEDGE SOLE RESPONSIBILITY FOR AND
                        ASSUME ALL RISK ARISING FROM YOUR USE OF THIRD-PARTY
                        DATA, THIRD PARTY PROPERTIES AND THIRD PARTY
                        APPLICATIONS. WE SHALL NOT BE LIABLE UNDER ANY
                        CIRCUMSTANCES FOR DAMAGES ARISING OUT OF OR IN ANY WAY
                        RELATED TO SOFTWARE, PRODUCTS, SERVICES, AND/OR
                        INFORMATION OFFERED OR PROVIDED BY THIRD PARTIES AND
                        ACCESSED THROUGH THE SERVICES.
                    </p>
                    <p>
                        NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED
                        HEREIN, IN NO EVENT SHALL THE MAXIMUM AGGREGATE
                        LIABILITY OF StellarFX LABS ARISING OUT OF OR IN ANY WAY
                        RELATED TO THIS AGREEMENT, OR YOUR ACCESS TO AND USE OF
                        THE SERVICE, EXCEED $500.
                    </p>
                    <p>
                        Some jurisdictions do not allow the exclusion or
                        limitation of incidental or consequential damages, so
                        the above limitation or exclusion may not apply to you.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            11.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            TERM AND TERMINATION.{' '}
                        </span>
                        Subject to this Section, the Agreement will remain in
                        full force and effect while you use the Services. We may
                        suspend or terminate your rights to use the Services at
                        any time for any reason at our sole discretion,
                        including for any use of the Services in violation of
                        the Agreement. Upon termination of your rights under the
                        Agreement, your right to access and use the Services
                        will terminate immediately. StellarFX Labs will not have
                        any liability whatsoever to you for any termination of
                        your rights under the Agreement.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            ARBITRATION CLAUSE AND CLASS ACTION WAIVER.{' '}
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Please read the following arbitration agreement in
                            this Section (“Arbitration Agreement”) carefully. It
                            requires that you and StellarFX Labs arbitrate
                            disputes against one another.
                        </span>
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            <u>Dispute Resolution:</u>
                        </span>
                        <span style={{ fontWeight: 'bold' }}> </span>
                        <span style={{ fontWeight: 'bold' }}>
                            PLEASE BE AWARE THAT THIS SECTION{' '}
                        </span>
                        <span style={{ fontWeight: 'bold' }}>12</span>
                        <span style={{ fontWeight: 'bold' }}> </span>
                        <span style={{ fontWeight: 'bold' }}>
                            CONTAINS PROVISIONS GOVERNING HOW DISPUTES THAT YOU
                            AND StellarFX LABS HAVE AGAINST EACH OTHER WILL BE
                            RESOLVED. AMONG OTHER THINGS, THIS SECTION{' '}
                        </span>
                        <span style={{ fontWeight: 'bold' }}>12</span>
                        <span style={{ fontWeight: 'bold' }}>
                            {' '}
                            INCLUDES AN AGREEMENT TO ARBITRATE WHICH REQUIRES,
                            WITH LIMITED EXCEPTIONS, THAT ALL DISPUTES BETWEEN
                            YOU AND StellarFX LABS BE RESOLVED BY BINDING AND
                            FINAL ARBITRATION. THIS SECTION{' '}
                        </span>
                        <span style={{ fontWeight: 'bold' }}>12</span>
                        <span style={{ fontWeight: 'bold' }}>
                            {' '}
                            ALSO CONTAINS A CLASS ACTION AND JURY TRIAL WAIVER.
                            PLEASE READ THIS SECTION{' '}
                        </span>
                        <span style={{ fontWeight: 'bold' }}>12</span>
                        <span style={{ fontWeight: 'bold' }}> CAREFULLY.</span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Applicability of Arbitration Agreement
                        </span>
                        . Subject to the terms of this Arbitration Agreement,
                        you and StellarFX Labs agree that any dispute, claim, or
                        disagreement arising out of or relating in any way to
                        your access to or use of the Services, any
                        communications you receive, or this Agreement, including
                        claims and disputes that arose between us before the
                        effective date of the Agreement (each, a “
                        <span style={{ fontWeight: 'bold' }}>Dispute</span>”)
                        will be resolved by binding arbitration, rather than in
                        court, except that: (1) you and StellarFX Labs may
                        assert claims or seek relief in small claims court if
                        such claims qualify and remain in small claims court;
                        and (2) you or StellarFX Labs may seek equitable relief
                        in court for infringement or other misuse of
                        intellectual property rights (such as trademarks, trade
                        dress, domain names, trade secrets, copyrights, and
                        patents). For purposes of this Arbitration Agreement, “
                        <span style={{ fontWeight: 'bold' }}>Dispute</span>”
                        will also include disputes that arose or involve facts
                        occurring before the existence of this or any prior
                        versions of this Agreement as well as claims that may
                        arise after the termination of the Agreement.&nbsp;{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Informal Dispute Resolution
                        </span>
                        . There may be instances when a Dispute arises between
                        you and StellarFX Labs. If that occurs, StellarFX Labs
                        is committed to working with you to reach a reasonable
                        resolution. You and StellarFX Labs agree that good faith
                        informal efforts to resolve Disputes can result in a
                        prompt, low‐cost and mutually beneficial outcome. You
                        and StellarFX Labs therefore agree that before either
                        party commences arbitration against the other (or
                        initiates an action in small claims court if a party so
                        elects), we will personally meet and confer
                        telephonically or via videoconference, in a good faith
                        effort to resolve informally any Dispute covered by this
                        Arbitration Agreement (“
                        <span style={{ fontWeight: 'bold' }}>
                            Informal Dispute Resolution Conference
                        </span>
                        ”). If you are represented by counsel, your counsel may
                        participate in the conference, but you also agree to
                        participate in the conference.
                    </p>
                    <p>
                        The party initiating a Dispute must give notice to the
                        other party in writing of its intent to initiate an
                        Informal Dispute Resolution Conference (“
                        <span style={{ fontWeight: 'bold' }}>Notice</span>”),
                        which shall occur within 45 days after the other party
                        receives such Notice, unless an extension is mutually
                        agreed upon by the parties in writing. Notice to
                        StellarFX Labs that you intend to initiate an Informal
                        Dispute Resolution Conference should be sent by email to{' '}
                        <a
                            target='_blank'
                            rel='noopener noreferrer'
                            href='mailto:legal@StellarFXlabs.io'
                        >
                            legal@StellarFXlabs.io
                        </a>{' '}
                        or regular mail to our offices located at 5020 Clark Rd.
                        #436, Sarasota, FL 34233. The Notice must include: (1)
                        your name, telephone number, mailing address, e‐mail
                        address associated with your account (if you have one);
                        (2) the name, telephone number, mailing address and
                        e‐mail address of your counsel, if any; and (3) a
                        description of your Dispute.
                    </p>
                    <p>
                        The Informal Dispute Resolution Conference shall be
                        individualized such that a separate conference must be
                        held each time either party initiates a Dispute, even if
                        the same law firm or group of law firms represents
                        multiple users in similar cases, unless all parties
                        agree; multiple individuals initiating a Dispute cannot
                        participate in the same Informal Dispute Resolution
                        Conference unless all parties agree. In the time between
                        a party receiving the Notice and the Informal Dispute
                        Resolution Conference, nothing in this Arbitration
                        Agreement shall prohibit the parties from engaging in
                        informal communications to resolve the initiating
                        party’s Dispute. Engaging in the Informal Dispute
                        Resolution Conference is a condition precedent and
                        requirement that must be fulfilled before commencing
                        arbitration. The statute of limitations and any filing
                        fee deadlines shall be tolled while the parties engage
                        in the Informal Dispute Resolution Conference process
                        required by this Section.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Waiver of Jury Trial
                        </span>
                        .{' '}
                        <span style={{ fontWeight: 'bold' }}>
                            <u>
                                YOU AND StellarFX LABS HEREBY WAIVE ANY
                                CONSTITUTIONAL AND STATUTORY RIGHTS TO SUE IN
                                COURT AND HAVE A TRIAL IN FRONT OF A JUDGE OR A
                                JURY
                            </u>
                        </span>
                        . You and StellarFX Labs are instead electing that all
                        Disputes shall be resolved by arbitration under this
                        Arbitration Agreement, except as specified in the
                        subsection entitled “Applicability of Arbitration
                        Agreement” above. There is no judge or jury in
                        arbitration, and court review of an arbitration award is
                        subject to very limited review.{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Waiver of Class and Other Non-Individualized Relief
                        </span>
                        .{' '}
                        <span style={{ fontWeight: 'bold' }}>
                            <u>
                                YOU AND StellarFX LABS AGREE THAT, EXCEPT AS
                                SPECIFIED IN SUBSECTION{' '}
                            </u>
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            <u>12.9</u>
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            <u>
                                {' '}
                                (BATCH ARBITRATION), EACH OF US MAY BRING CLAIMS
                                AGAINST THE OTHER ONLY ON AN INDIVIDUAL BASIS
                                AND NOT ON A CLASS, REPRESENTATIVE, OR
                                COLLECTIVE BASIS, AND THE PARTIES HEREBY WAIVE
                                ALL RIGHTS TO HAVE ANY DISPUTE BE BROUGHT,
                                HEARD, ADMINISTERED, RESOLVED, OR ARBITRATED ON
                                A CLASS, COLLECTIVE, REPRESENTATIVE, OR MASS
                                ACTION BASIS. ONLY INDIVIDUAL RELIEF IS
                                AVAILABLE, AND DISPUTES OF MORE THAN ONE
                                CUSTOMER OR USER CANNOT BE ARBITRATED OR
                                CONSOLIDATED WITH THOSE OF ANY OTHER CUSTOMER OR
                                USER
                            </u>
                        </span>
                        . Subject to this Arbitration Agreement, the arbitrator
                        may award declaratory or injunctive relief only in favor
                        of the individual party seeking relief and only to the
                        extent necessary to provide relief warranted by the
                        party’s individual claim. Nothing in this paragraph is
                        intended to, nor shall it, affect the terms and
                        conditions under the subsection 12.9 (Batch Arbitration)
                        entitled “
                        <span style={{ fontWeight: 'bold' }}>
                            Batch Arbitration.
                        </span>
                        ” Notwithstanding anything to the contrary in this
                        Arbitration Agreement, if a court decides by means of a
                        final decision, not subject to any further appeal or
                        recourse, that the limitations of this subsection, “
                        <span style={{ fontWeight: 'bold' }}>
                            Waiver of Class and Other Non-Individualized Relief,
                        </span>
                        ” are invalid or unenforceable as to a particular claim
                        or request for relief (such as a request for public
                        injunctive relief), you and StellarFX Labs agree that
                        that particular claim or request for relief (and only
                        that particular claim or request for relief) shall be
                        severed from the arbitration and may be litigated in the
                        state or federal courts located in Florida. All other
                        Disputes shall be arbitrated or litigated in small
                        claims court. This subsection does not prevent you or
                        StellarFX Labs from participating in a class-wide
                        settlement of claims.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Rules and Forum
                        </span>
                        . This Agreement evidences a transaction involving
                        interstate commerce; and notwithstanding any other
                        provision herein with respect to the applicable
                        substantive law, the Federal Arbitration Act, 9 U.S.C. §
                        1 et seq., will govern the interpretation and
                        enforcement of this Arbitration Agreement and any
                        arbitration proceedings. If the Informal Dispute
                        Resolution Conference described above does not resolve
                        satisfactorily within sixty (60) days after receipt of
                        Notice, you and StellarFX Labs agree that either party
                        shall have the right to finally resolve the Dispute
                        through binding arbitration. The arbitration will be
                        conducted by JAMS, an established alternative dispute
                        resolution provider. Disputes involving claims,
                        counterclaims, or request for relief under $250,000, not
                        inclusive of attorneys’ fees and interest, shall be
                        subject to JAMS’s most current version of the
                        Streamlined Arbitration Rules and procedures available
                        at{' '}
                        <a
                            target='_blank'
                            rel='noopener noreferrer'
                            href='https://www.jamsadr.com/rules-streamlined-arbitration/'
                        >
                            www.jamsadr.com/rules-streamlined-arbitration/
                        </a>
                        ; all other disputes shall be subject to JAMS’s most
                        current version of the Comprehensive Arbitration Rules
                        and Procedures, available at{' '}
                        <a
                            target='_blank'
                            rel='noopener noreferrer'
                            href='https://www.jamsadr.com/rules-comprehensive-arbitration/'
                        >
                            www.jamsadr.com/rules-comprehensive-arbitration/
                        </a>
                        . JAMS’s rules are also available at{' '}
                        <a
                            target='_blank'
                            rel='noopener noreferrer'
                            href='https://www.jamsadr.com'
                        >
                            www.jamsadr.com
                        </a>{' '}
                        or by calling JAMS at 800-352-5267. If JAMS is not
                        available to arbitrate, the parties will select an
                        alternative arbitral forum. Your responsibility to pay
                        any JAMS fees and costs will be solely as set forth in
                        the applicable JAMS rules.&nbsp;{' '}
                    </p>
                    <p>
                        A party who wishes to initiate arbitration must provide
                        the other party with a request for arbitration (the “
                        <span style={{ fontWeight: 'bold' }}>Request</span>”).
                        The Request must include: (1) the name, telephone
                        number, mailing address, e‐mail address of the party
                        seeking arbitration and the account information (if
                        applicable); (2) a statement of the legal claims being
                        asserted and the factual bases of those claims; (3) a
                        description of the remedy sought and an accurate,
                        good‐faith calculation of the amount in controversy in
                        United States Dollars; (4) a statement certifying
                        completion of the Informal Dispute Resolution process as
                        described above; and (5) evidence that the requesting
                        party has paid any necessary filing fees in connection
                        with such arbitration.{' '}
                    </p>
                    <p>
                        If the party requesting arbitration is represented by
                        counsel, the Request shall also include counsel’s name,
                        telephone number, mailing address, and email address.
                        Such counsel must also sign the Request. By signing the
                        Request, counsel certifies to the best of counsel’s
                        knowledge, information, and belief, formed after an
                        inquiry reasonable under the circumstances, that: (1)
                        the Request is not being presented for any improper
                        purpose, such as to harass, cause unnecessary delay, or
                        needlessly increase the cost of dispute resolution; (2)
                        the claims, defenses and other legal contentions are
                        warranted by existing law or by a nonfrivolous argument
                        for extending, modifying, or reversing existing law or
                        for establishing new law; and (3) the factual and
                        damages contentions have evidentiary support or, if
                        specifically so identified, will likely have evidentiary
                        support after a reasonable opportunity for further
                        investigation or discovery.&nbsp;{' '}
                    </p>
                    <p>
                        Unless you and otherwise agree, or the Batch Arbitration
                        process discussed in subsection 12.9 (Batch Arbitration)
                        is triggered, the arbitration will be conducted in the
                        county where you reside. Subject to the applicable JAMS
                        rules, the arbitrator may direct a limited and
                        reasonable exchange of information between the parties,
                        consistent with the expedited nature of the arbitration.{' '}
                    </p>
                    <p>
                        You and StellarFX Labs agree that all materials and
                        documents exchanged during the arbitration proceedings
                        shall be kept confidential and shall not be shared with
                        anyone except the parties’ attorneys, accountants, or
                        business advisors, and then subject to the condition
                        that they agree to keep all materials and documents
                        exchanged during the arbitration proceedings
                        confidential.{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>Arbitrator</span>.
                        The arbitrator will be either a retired judge or an
                        attorney licensed to practice law in the state of
                        Florida and will be selected by the parties from the
                        JAMS roster of consumer dispute arbitrators. If the
                        parties are unable to agree upon an arbitrator within
                        thirty-five (35) days of delivery of the Request, then
                        JAMS will appoint the arbitrator in accordance with the
                        applicable JAMS rules, provided that if the Batch
                        Arbitration process under subsection 12.9 (Batch
                        Arbitration) is triggered, JAMS will appoint the
                        arbitrator for each batch.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Authority of Arbitrator
                        </span>
                        . The arbitrator shall have exclusive authority to
                        resolve any Dispute, including, without limitation,
                        disputes arising out of or related to the interpretation
                        or application of the Arbitration Agreement, including
                        the enforceability, revocability, scope, or validity of
                        the Arbitration Agreement or any portion of the
                        Arbitration Agreement, except for the following: (1) all
                        Disputes arising out of or relating to the subsection
                        entitled “
                        <span style={{ fontWeight: 'bold' }}>
                            Waiver of Class and Other Non-Individualized Relief,
                        </span>
                        ” including any claim that all or part of the subsection
                        entitled “
                        <span style={{ fontWeight: 'bold' }}>
                            Waiver of Class and Other Non-Individualized Relief
                        </span>
                        ” is unenforceable, illegal, void or voidable, or that
                        such subsection entitled “
                        <span style={{ fontWeight: 'bold' }}>
                            Waiver of Class and Other Non-Individualized Relief
                        </span>
                        ” has been breached, shall be decided by a court of
                        competent jurisdiction and not by an arbitrator; (2)
                        except as expressly contemplated in the subsection
                        entitled “
                        <span style={{ fontWeight: 'bold' }}>
                            Batch Arbitration,
                        </span>
                        ” all Disputes about the payment of arbitration fees
                        shall be decided only by a court of competent
                        jurisdiction and not by an arbitrator; (3) all Disputes
                        about whether either party has satisfied any condition
                        precedent to arbitration shall be decided only by a
                        court of competent jurisdiction and not by an
                        arbitrator; and (4) all Disputes about which version of
                        the Arbitration Agreement applies shall be decided only
                        by a court of competent jurisdiction and not by an
                        arbitrator. The arbitration proceeding will not be
                        consolidated with any other matters or joined with any
                        other cases or parties, except as expressly provided in
                        the subsection entitled “
                        <span style={{ fontWeight: 'bold' }}>
                            Batch Arbitration.
                        </span>
                        ” The arbitrator shall have the authority to grant
                        motions dispositive of all or part of any Dispute. The
                        arbitrator shall issue a written award and statement of
                        decision describing the essential findings and
                        conclusions on which the award is based, including the
                        calculation of any damages awarded. The award of the
                        arbitrator is final and binding upon you and us.
                        Judgment on the arbitration award may be entered in any
                        court having jurisdiction.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Attorneys’ Fees and Costs
                        </span>
                        . The parties shall bear their own attorneys’ fees and
                        costs in arbitration unless the arbitrator finds that
                        either the substance of the Dispute or the relief sought
                        in the Request was frivolous or was brought for an
                        improper purpose (as measured by the standards set forth
                        in Federal Rule of Civil Procedure 11(b)). If you or
                        StellarFX Labs need to invoke the authority of a court
                        of competent jurisdiction to compel arbitration, then
                        the party that obtains an order compelling arbitration
                        in such action shall have the right to collect from the
                        other party its reasonable costs, necessary
                        disbursements, and reasonable attorneys’ fees incurred
                        in securing an order compelling arbitration. The
                        prevailing party in any court action relating to whether
                        either party has satisfied any condition precedent to
                        arbitration, including the Informal Dispute Resolution
                        Conference, is entitled to recover their reasonable
                        costs, necessary disbursements, and reasonable
                        attorneys’ fees and costs.{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.9&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Batch Arbitration
                        </span>
                        . To increase the efficiency of administration and
                        resolution of arbitrations, you and StellarFX Labs agree
                        that in the event that there are one hundred (100) or
                        more individual Requests of a substantially similar
                        nature filed against StellarFX Labs by or with the
                        assistance of the same law firm, group of law firms, or
                        organizations, within a thirty (30) day period (or as
                        soon as possible thereafter), JAMS shall (1) administer
                        the arbitration demands in batches of 100 Requests per
                        batch (plus, to the extent there are less than 100
                        Requests left over after the batching described above, a
                        final batch consisting of the remaining Requests); (2)
                        appoint one arbitrator for each batch; and (3) provide
                        for the resolution of each batch as a single
                        consolidated arbitration with one set of filing and
                        administrative fees due per side per batch, one
                        procedural calendar, one hearing (if any) in a place to
                        be determined by the arbitrator, and one final award (“
                        <span style={{ fontWeight: 'bold' }}>
                            Batch Arbitration
                        </span>
                        ”).
                    </p>
                    <p>
                        All parties agree that Requests are of a “
                        <span style={{ fontWeight: 'bold' }}>
                            substantially similar nature
                        </span>
                        ” if they arise out of or relate to the same event or
                        factual scenario and raise the same or similar legal
                        issues and seek the same or similar relief. To the
                        extent the parties disagree on the application of the
                        Batch Arbitration process, the disagreeing party shall
                        advise JAMS, and JAMS shall appoint a sole standing
                        arbitrator to determine the applicability of the Batch
                        Arbitration process (“
                        <span style={{ fontWeight: 'bold' }}>
                            Administrative Arbitrator
                        </span>
                        ”). In an effort to expedite resolution of any such
                        dispute by the Administrative Arbitrator, the parties
                        agree the Administrative Arbitrator may set forth such
                        procedures as are necessary to resolve any disputes
                        promptly. The Administrative Arbitrator’s fees shall be
                        paid by StellarFX Labs.
                    </p>
                    <p>
                        You and StellarFX Labs agree to cooperate in good faith
                        with JAMS to implement the Batch Arbitration process
                        including the payment of single filing and
                        administrative fees for batches of Requests, as well as
                        any steps to minimize the time and costs of arbitration,
                        which may include: (1) the appointment of a discovery
                        special master to assist the arbitrator in the
                        resolution of discovery disputes; and (2) the adoption
                        of an expedited calendar of the arbitration proceedings.
                        This Batch Arbitration provision shall in no way be
                        interpreted as authorizing a class, collective and/or
                        mass arbitration or action of any kind, or arbitration
                        involving joint or consolidated claims under any
                        circumstances, except as expressly set forth in this
                        provision.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.10&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            30-Day Right to Opt Out
                        </span>
                        . You have the right to opt out of the provisions of
                        this Arbitration Agreement by sending written notice of
                        your decision to opt out to: 5020 Clark Rd., #436,
                        Sarasota, FL 34233, within thirty (30) days after first
                        becoming subject to this Arbitration Agreement. Your
                        notice must include your name and address,&nbsp; and an
                        unequivocal statement that you want to opt out of this
                        Arbitration Agreement. If you opt out of this
                        Arbitration Agreement, all other parts of the Agreement
                        will continue to apply to you. Opting out of this
                        Arbitration Agreement has no effect on any other
                        arbitration agreements that you may currently have, or
                        may enter in the future, with us.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.11&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Invalidity, Expiration
                        </span>
                        . Except as provided in the subsection entitled “
                        <span style={{ fontWeight: 'bold' }}>
                            Waiver of Class or Other Non-Individualized Relief
                        </span>
                        ”, if any part or parts of this Arbitration Agreement
                        are found under the law to be invalid or unenforceable,
                        then such specific part or parts shall be of no force
                        and effect and shall be severed and the remainder of the
                        Arbitration Agreement shall continue in full force and
                        effect. You further agree that any Dispute that you have
                        with StellarFX Labs as detailed in this Arbitration
                        Agreement must be initiated via arbitration within the
                        applicable statute of limitation for that claim or
                        controversy, or it will be forever time barred.
                        Likewise, you agree that all applicable statutes of
                        limitation will apply to such arbitration in the same
                        manner as those statutes of limitation would apply in
                        the applicable court of competent jurisdiction.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            12.12&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>Modification</span>
                        . Notwithstanding any provision in the Agreement to the
                        contrary, we agree that if StellarFX Labs makes any
                        future material change to this Arbitration Agreement, it
                        will notify you. Unless you reject the change within
                        thirty (30) days of such change becoming effective by
                        writing to StellarFX Labs at: 5020 Clark Rd., #436,
                        Sarasota, FL 34233, your continued use of the Services,
                        including the acceptance of products and services
                        offered on or through the Services, following the
                        posting of changes to this Arbitration Agreement
                        constitutes your acceptance of any such changes. Changes
                        to this Arbitration Agreement do not provide you with a
                        new opportunity to opt out of the Arbitration Agreement
                        if you have previously agreed to a version of the
                        Agreement and did not validly opt out of arbitration. If
                        you reject any change or update to this Arbitration
                        Agreement, and you were bound by an existing agreement
                        to arbitrate Disputes arising out of or relating in any
                        way to your access to or use of the Services, any
                        communications you receive, any products sold or
                        distributed through the Services or the Agreement, the
                        provisions of this Arbitration Agreement as of the date
                        you first accepted the Agreement (or accepted any
                        subsequent changes to the Agreement) remain in full
                        force and effect. StellarFX Labs will continue to honor
                        any valid opt outs of the Arbitration Agreement that you
                        made to a prior version of the Agreement.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>GENERAL</span>
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Not Registered with the SEC or Any Other Agency.{' '}
                        </span>
                        We are not registered with the U.S. Securities and
                        Exchange Commission as a national securities exchange or
                        in any other capacity. You understand and acknowledge
                        that we do not broker trading orders on your behalf. We
                        also do not facilitate the execution or settlement of
                        your trades, which occur entirely on public distributed
                        blockchains like Ethereum. As a result, we do not (and
                        cannot) guarantee market best pricing or best execution
                        through our Services.{' '}
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Electronic Communications
                        </span>
                        . The communications between you and StellarFX Labs may
                        take place via electronic means, whether you visit the
                        Services or send StellarFX Labs e-mails or other
                        electronic communications, or whether StellarFX Labs
                        posts notices on the Services or communicates with you
                        via other commercially reasonable means (e.g.,
                        airdropping notice to a Digital Wallet address). For
                        contractual purposes, you (a) consent to receive
                        communications from StellarFX Labs in an electronic
                        form; and (b) agree that all terms and conditions,
                        agreements, notices, disclosures, and other
                        communications that StellarFX Labs provides to you
                        electronically satisfy any legal requirement that such
                        communications would satisfy if it were to be in
                        writing. The foregoing does not affect your statutory
                        rights, including but not limited to the Electronic
                        Signatures in Global and National Commerce Act at 15
                        U.S.C. §7001 et seq.&nbsp;{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>Assignment</span>.
                        The Agreement, and your rights and obligations
                        hereunder, may not be assigned, subcontracted, delegated
                        or otherwise transferred by you, by operation of law or
                        otherwise, without StellarFX Labs’ prior written
                        consent, and any attempted assignment, subcontract,
                        delegation, or transfer in violation of the foregoing
                        will be null and void.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Force Majeure
                        </span>
                        . StellarFX Labs shall not be liable for any delay or
                        failure to perform resulting from causes outside its
                        reasonable control, including, but not limited to, acts
                        of God, war, terrorism, riots, embargos, acts of civil
                        or military authorities, fire, floods, accidents,
                        strikes or shortages of transportation facilities, fuel,
                        energy, labor or materials.{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Governing Law
                        </span>
                        . THE AGREEMENT AND ANY ACTION RELATED THERETO WILL BE
                        GOVERNED AND INTERPRETED BY AND UNDER THE LAWS OF
                        FLORIDA, CONSISTENT WITH THE FEDERAL ARBITRATION ACT,
                        WITHOUT GIVING EFFECT TO ANY PRINCIPLES THAT PROVIDE FOR
                        THE APPLICATION OF THE LAW OF ANOTHER JURISDICTION. THE
                        UNITED NATIONS CONVENTION ON CONTRACTS FOR THE
                        INTERNATIONAL SALE OF GOODS DOES NOT APPLY TO THE
                        AGREEMENT. To the extent the parties are permitted under
                        the Agreement to initiate litigation in a court, both
                        you and StellarFX Labs agree that all claims and
                        disputes arising out of or relating to the Agreement
                        will be litigated exclusively in the state or federal
                        courts located in Florida.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>Notice</span>.
                        StellarFX Labs may deliver notices to you under this
                        Agreement via commercially reasonable means (e.g.,
                        airdropping notice to a Digital Wallet address). If
                        StellarFX Labs is for any reason not capable of
                        delivering to you any notices required/ permitted by the
                        Agreement, StellarFX Labs’ dispatch of the communication
                        containing such notice will nonetheless constitute
                        effective notice. You may give notice to StellarFX Labs
                        at the following address: 5020 Clark Rd. #436, Sarasota,
                        FL 34233. Such notice shall be deemed given when
                        received by StellarFX Labs by letter delivered by
                        nationally recognized overnight delivery service or
                        first class postage prepaid mail at the above address.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>Waiver</span>. Any
                        waiver or failure to enforce any provision of the
                        Agreement on one occasion will not be deemed a waiver of
                        any other provision or of such provision on any other
                        occasion.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>Severability</span>
                        . If any portion of the Agreement is held invalid or
                        unenforceable, that portion shall be construed in a
                        manner to reflect, as nearly as possible, the original
                        intention of the parties, and the remaining portions
                        shall remain in full force and effect.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.9&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            International Users
                        </span>
                        . The Website and other parts of the Services can be
                        accessed from countries around the world and may contain
                        references to services and content that are not
                        available in your country. These references do not imply
                        that StellarFX Labs intends to announce such services or
                        content in your country.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.10&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Export Control
                        </span>
                        . The Services may be subject to U.S. export control
                        laws and may be subject to export or import regulations
                        in other countries. You agree not to export, reexport,
                        or transfer, directly or indirectly, any U.S.&nbsp;
                        technical data acquired from StellarFX Labs, or any
                        products utilizing such data, in violation of the United
                        States export laws or regulations.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.11&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Copyright/Trademark Information.{' '}
                        </span>
                        Copyright © 2024, StellarFX Labs, Inc. All rights
                        reserved. All trademarks, logos and service marks (“
                        <span style={{ fontWeight: 'bold' }}>Marks</span>”)
                        displayed on the Services are our property or the
                        property of other third parties. You are not permitted
                        to use these Marks without our prior written consent or
                        the consent of such third party which may own the Marks.
                        All goodwill generated from the use of any StellarFX
                        Labs Marks will inure to StellarFX Labs’ benefit.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.12&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Questions, Complaints, Claims
                        </span>
                        . If you have any questions, complaints or claims with
                        respect to the Services, please contact us at the
                        contact information below. We will do our best to
                        address your concerns. If you feel that your concerns
                        have been addressed incompletely, we invite you to let
                        us know for further investigation. In addition, in
                        accordance with California Civil Code §1789.3, you may
                        report complaints to the Complaint Assistance Unit of
                        the Division of Consumer Services of the California
                        Department of Consumer Affairs by contacting them in
                        writing at 1625 North Market Blvd., Suite N 112,
                        Sacramento, CA 95834, or by telephone at (800) 952-5210.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.13&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Entire Agreement
                        </span>
                        . The Agreement is the final, complete and exclusive
                        agreement of the parties with respect to the subject
                        matter hereof and supersedes and merges all prior
                        discussions between the parties with respect to such
                        subject matter.
                    </p>
                    {/* <p>
                        <span style={{ fontWeight: 'bold' }}>
                            13.14&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                        <span style={{ fontWeight: 'bold' }}>
                            Contact Information:
                        </span>
                        <span style={{ fontWeight: 'bold' }}> </span>
                    </p>
                    <span>&nbsp;</span>
                    <span>
                        <a
                            target='_blank'
                            rel='noopener noreferrer'
                            href='mailto:legal@StellarFXlabs.io'
                        >
                            legal@StellarFXlabs.io
                        </a>
                    </span>
                    <span>5020 Clark Rd., #436</span>
                    <span>Sarasota, FL 34233</span>
                    <span>United States</span> */}
                    <span>&nbsp;</span>
                </div>
            </div>
        </div>
    );
}
